const messages = {
    fields: {
        first_name: 'Fornavn',
        last_name: 'Efternavn',
        address: 'Adresse',
        postcode: 'Postnummer',
        city: 'By',
        phone: 'Telefonnummer',
        house_number: 'Nummer',
        password: 'Password',
    },
    customPages: {
        mainCategory: 'hovedkategorier',
    },
    validations: {
        required: '{field} er forpligtet',
        invalid: '{field} er forkert',
    },
    blockCart: {
        addToCart: 'Tilføj indkøbskurv',
        addedToCartTitle: 'Tilføjet til din indkøbskurv',
        proceedToCheckout: 'Indkøbskurv',
        productTotal: 'Total',
        showAllProducts: 'Vis alle produkter',
        cartShipping: 'Leveringsomkostninger',
        cartTotal: 'Total',
        close: 'Luk',
        addedToCartChoiceTitle: 'Dit valg:',
        noItemSelected: 'Ingen variant er valgt!',
    },
    myAccount: {
        titlePersonalInformation: 'Mine data',
        adjustData: 'ændre informationer',
        setNewPassword: 'ndstil nyt adgangskode?',
        phoneNumberMessage: 'De kan blive kontaktet af Postnord med henblik på levering',
        houseNumber: 'Nr',
        optional: 'valgfri',
        currentPassword: 'Nuværende adgangskode',
        newPassword: 'Ny adgangskode',
        email: 'E-mail',
        titleOrderHistory: 'Bestilling',
        logout: 'Log ud',
        loading: 'Åbner...',
        yourCart: 'Din indkøbskurv',
        address2: 'Adresszusatz',
        addAddress: 'Tilføj adresse',
        defaultAddress: 'Standard adresse',
        setAsDefaultAddress: 'opret standard adresse',
        adjust: 'Justere',
        name: 'Navn',
        firstName: 'Fornavn',
        lastName: 'Efternavn',
        address: 'Adresse',
        zipcode: 'Postnummer',
        residence: 'Bopæl',
        country: 'Land',
        phone: 'Telefon',
        phoneNumber: 'Telefon nummer',
        copyAddress: 'kopi adresse',
        delete: 'Slet',
        errorMessage: 'Ups! Fejl fundet ',
        cancel: 'Annuller',
        save: 'Gem',
        packaging: 'Emballage',
        unitPrice: 'Enhedspris',
        price: 'Pris',
        totalPriceProducts: 'Total pris bestilte product(er)',
        total: 'Total',
        freeOfCharge: 'Gratis!',
        taxIncl: 'incl. Moms',
        continueToOrder: 'fortsæt til ordre',
        easyReorder: 'Nem genbestilling!',
        easyReorderMessage: 'Tilføj produkter fra tidligere ordrer og betal.',
        emtpyOrderMessage:
            'Når du har placeret en ordre, vises den her med information om leveringstid, din faktura osv. Du kan også nemt genbestille tidligere ordrer fra denne side.',
        emtpyOrderMessage2: 'Klik',
        emtpyOrderMessage3: 'her',
        emtpyOrderMessage4: 'for at gå til hjemmesiden.',
        reorder: 'Ombestillinger',
        products: 'Produkt(er)',
        totalShipmentCost: 'Samlede forsendelsesomkostninger',
        shipmentCost: 'forsendelsesomkostninger',
        status: 'Status',
        detailsInvoice: 'Detaljer & faktura',
        downloadInvoice: 'Download faktura',
        shippedBy: 'Sendt af',
        paymentMethod: 'Betalingsmetode',
        deleteAddressModalText: 'Er du sikker på, at du vil slette denne adresse?',
        deleteAddressModalLoaderText: 'Sletning',
        errorModalText: 'Beklager, der gik noget galt',
        errorModalText2: 'Prøv igen senere',
        appModalTitle: 'Brekz - Online kæledyrsbutik - App',
        appModalText:
            'Du kan til enhver tid bestille alt til dit kæledyr? Fra nu af kan du nemt gøre dette via Brekz-appen.\\n' +
            'Bestil let tusinder af ting såsom mad, velsmagende snacks og sjovt legetøj på et sted.',
        appModalText2: 'Du kan finde appen i Play Store og App Store',
        appModalListTitle: 'Fordele',
        appModalListItem: '- Hav altid din kæledyrsbutik til rådighed',
        appModalListItem1: ' - Nem og hurtig ombestilling',
        appModalListItem2: '- Nyttige meddelelser om ordrer',
        appModalListItem3: '- Indstil hvilke \\/ hvor mange underretninger du vil modtage',
        appModalListItemLink: 'Tilbud',
        reorderModalSorry: 'Er desværre ikke på lager',
        reorderModalOutOfStock: 'ikke leveres',
        reorderModalPackaging: 'Dette produkt kan \n',
        reorderModalSkip: 'Spring dette produkt over\n',
        reorderModalAlternativesInStock: 'Alternative produkter, som er på lager',
        reorderModalQuantity: 'Antal',
        pricePerUnit: 'Pris pr stk',
        addProduct: 'Tilføj',
        bundleDiscount: 'Mængderabat',
        discount: 'Spar',
        reorderModalOrderAlternative: 'Bestil alternativt produkt',
        saveConfirmationModalTitle: 'Dine data er gemt',
        minimumPurchaseMessage:
            'Den mindste ordreværdi er {amount} (eksklusive leveringsomkostninger) Tilføj 1 eller flere produkter til din indkøbskurv for at fortsætte.',
        trackAndTraceText: 'Spor din ordre (tilgængelig efter levering af din pakke)',
        noAlternativeProducts: 'Der findes desværre ikke noget alternativt produkt til din tidligere bestilling',
        addressDescription: 'Her kan du se en oversigt med dine adresseoplysninger. Du kan også ændre dem her\n',
        titleMyOrders: 'Mine ordrer',
        orderDescription: 'Se status på din bestilling, din faktura eller lav en nem genbestilling\n',
        orderDescriptionShort: 'Se status på din bestilling\n',
        addresses: 'Mine adresser',
        okay: 'Okay',
        errorFirstName: 'Skriv korrekt fornavn',
        errorLastName: 'Skriv korrekt efternavn',
        errorEmail: 'Skriv en korrekt mailadresse',
        errorPhone: 'Kontroller dit telefonnummer',
        errorAddress: 'Kontroller gadenavn og husnummer (nummer i det næste felt)',
        errorAddress2: 'Kontroller gadenavn og husnummer (nummer i det næste felt)',
        errorZipcode: 'Postnummer ikke korrekt',
        errorCity: 'Kontroller din bopæl',
        errorPassword: 'Wachtwoord ontbreekt of is te kort',
        eraseWarning: 'Du skal til at slette alle udfyldte oplysninger!',
        eraseConfirmation: 'Er du helt sikker?',
        amount: 'Antal',
        orderDate: 'Bestillingsdato',
        trackAndTrace: 'Track & Trace',
        close: 'Luk',
        toCart: 'Gå til indkøbskurv',
        productsInCart: 'Der er lagt produkter i din indkøbskurv',
        orderInCart: 'Din bestilling er lagt i din indkøbskurv',
        productsInColumn:
            'Du kan finde dem i højre kolonne på denne side, eller klik på det lille indkøbsvognikon øverst til højre på siden',
        orderStatus: 'Status på din bestilling',
        orderProcess: 'Din bestilling gennemgår for det meste de følgende trin:',
        paymentWaiting: 'Afventer din betaling',
        paymentReceived: 'Betaling modtaget',
        orderCollected: 'Bestillingen bliver samlet',
        orderSent: 'Din bestilling er sendt',
        followOrder: 'Du kan nu følge din pakke via ',
        followOrderEnd: '.',
        multiplePackages: 'NB: Bestelling bevat meerdere pakketten',
        trackAndTraceActiveTime: 'det kan tage et stykke tid, før linket bliver aktivt',
        delivered: 'Leveret',
        password: 'Password',
        didYouMean: 'Mener du måske',
        apply: 'Ansøg',
        bundle: 'Pakke',
        bundlePriceWas: 'Vask',
        saving: 'Spar',
    },
    checkout: {
        between: 'Mellem',
        and: 'Og',
        delivery: 'Levering',
        countdownMessage1: 'Bestil inden',
        countdownMessage2: 'For den hurtigste levering',
        newCard: 'Brug nyt kreditkort',
        creditCard: 'kreditkort',
        addNewCard: 'Tilføj nyt {card}',
        passwordMessage: 'Minimum 5 karakterer',
        loading: 'Åbner...',
        lastStep: 'Sidste trin',
        savedCard: 'Brug gemt {card}',
        cardNumber: 'Kortnummer',
        otherCard: 'Brug {card} i stedet',
        expireDate: 'Udløbsdato',
        errorCard: 'Dette kort er ikke gyldigt eller understøttes ikke',
        errorName: 'Nuværende navn er ugyldigt',
        errorDate: 'Nuværende Udløbsdato er ugyldig eller udløbet',
        errorCVV: 'Nuværende CVV er ugyldig',
        cardExpired: 'Dette kort er udløbet i vores system. Udfyld venligst kortet igen.',
        saveCard: 'Gem {card}',
        nextTime: 'til næste gang',
        order: 'Bestil',
        back: 'Gå tilbage til betalingsmuligheder',
        addressEdit: 'Opdater adresse',
        paymentSucces: 'Din betaling er modtaget',
        backToOrderhistory: 'Du vil blive sendt videre til din ordreoversigt om et par sekunder',
        bancontactNotAvailable: 'Bankontakt er ikke tilgængelig på DK',
        allData: 'Alle dine data er',
        secured: 'sikrede',
        almostDone: 'Næsten færdig',
        banContactNotAvailable: 'Bancontact is niet beschiktbaar op',
        payWith: 'Reken af met uw',
        bancontactApp: 'Bancontact app',
        useOtherBancontact: 'Andere Bancontact gebruiken',
        useNewBancontact: 'Nieuwe Bancontact gebruiken',
        addNewBancontact: 'Nieuwe Bancontact toevoegen',
        payWithBancontactApp: 'Betaal met de bancontact App',
        openBancontactApp: 'Open de bancontact app en scan de code om de betaling met de app af te ronden',
        noBancontactApp: 'Heeft u de app niet? Gebruik dan de methode hiernaast.',
        mistercacheSave: 'Bancontact opslaan',
        cardHolderNamePlaceholder: 'J. JENSEN',
        newAccount: 'Dine personlige oplysninger',
        cancel: 'Annuller',
        taxIncl: 'incl. Moms',
        total: 'Total',
        name: 'Navn',
        close: 'Sluiten',
        errorText: 'Beklager, der gik noget galt',
        errorModalText: 'Beklager, der gik noget galt',
        errorModalText2: 'Prøv igen senere',
        rememberAddressHeaderTitle: 'Spar tid ved din næste bestilling',
        rememberAddressSwitchLabel: 'Brug denne adresse og betalingsmåde ved næste bestillinger',
        paymentSecurityText: 'Alle dine data er',
        paymentSecurityTextBold: 'sikret',
        paymentCardHeaderTitle: 'Betalingsmuligheder',
        addressCardHeaderTitle: 'Leveringsadresse',
        invoiceAddress: 'Fakturaens adresse',
        editAddress: 'Juster',
        addNewAddress: 'Tilføj ny adresse',
        addNewInvoiceAddress: 'TilfØj ny faktureringsadresse',
        addressMatchesInvoiceAddress: 'Faktura-adresse er magen til modtager-adresse',
        addressMatchesNotInvoiceAddress: 'Faktura-adresse er ikke magen til modtager-adresse',
        // checkout progressbar
        progressbarLogIn: 'Log ind',
        progressbarPaymentOption: 'Betalingsmetode',
        progressbarPayment: 'Betaling',
        progressbarDone: 'Godkendt!',
        klarnaPhoneNumberRequiredModal: {
            modalMessage:
                'Du har valgt at betale med <strong>Klarna</strong> efterfølgende. Derfor har vi brug for dit telefonnummer',
            phoneNumberInputField: 'Udfyld venligst dit telefonnummer her',
            otherPaymentMethod: 'Other payment method',
        },
        validationErrors: {
            noPaymentMethodSelected: 'Du har endnu ikke valgt betalingsmetod',
            noAddressSelected: 'Du har endnu ikke valgt en modtager- og/eller faktura-adresse',
            paymentMethodRequiresPhoneNumber:
                'Tilføj venligst dit telefonnummer til adressen, for at betale med Klarna.',
            termsOfServices: 'U heeft de Algemene voorwaarden niet geaccepteerd',
            noDeliveryOnThisAddress:
                'Vi leverer desværre ikke til det postnummer, du har udfyldt. For at bestille, kan du vælge at få pakken leveret til et andet postnummer.',
        },
        processWaiting: {
            title: 'Betalingen er under behandling',
            description: 'Et øjeblik Tak',
        },
    },
    address: {
        placeholderFirstname: 'Jan',
        placeholderLastname: 'Janssen',
        placeholderAddress: 'Gadenavn',
        placeholderAddress2: 'Etage/lejl, Firma ',
        placeholderZipcode: '1234',
        placeholderCity: 'Kobenhavn',
        placeholderPhone: '0123456789',
        noShipping:
            'På dette postnummer skal du desværre betale ekstra forsendelsesudgifter. For at undgå disse omkostninger, kan du få pakken leveret til et andet postnummer.',
    },
    outOfStockNotificationOptin: {
        modalTitle: 'Hold mig opdateret',
        modalMessage: 'Du vil modtage én e-mail, når dette produkt er kommet på lager igen.',
        modalSubmitButton: 'Hold mig opdateret',
        email: 'E-mail',
        placeholderEmail: 'eksempel@email.com',
        noAbuse: 'Din e-mailadresse vil ikke blive brugt til andre formål.',
        alreadySignedUp: 'Du ér allerede tilmeldt beskedservice via e-mail, om dette produkt.',
        invalidEmail: 'Ugyldig e-mail adress',
        genericError: 'Noget gik galt',
    },
    orderConfirmation: {
        modalTitle: 'Vil du følge din ordre?',
        modalMessage:
            'Du har bestilt som gæst. Hvis du tilføjer en adgangskode, kan du følge din ordre på din personlige konto.',
        enterPassword: 'Tilføj adgangskode',
        minimumWarning: 'Mindst 5 tegn',
        passwordTooShort: 'Din kode er for kort',
        somethingWentWrong: 'Der er opstået en fejl',
    },
    unsubPage: {
        emailQuestion: 'Til hvilken e-mail-adresse?',
        emailKnown: 'E-mail-adresse fra din konto: ',
        emailadres: 'E-mailadresse:',
        changeEmailSettings: 'Ændring af e-mail indstillinger ',
        iWant: 'Ønsker',
        iWant2: 'Ik wil',
        keepProfiting: 'stadig at modtage  ',
        ofTheBenefitMail: 'tilbudsmails',
        sendMe: 'Send mig',
        onesEvery2Weeks: 'eksklusive tilbud og de bedste rabatter',
        exclusiveOffersAndTheBestDiscounts: ', hver anden uge',
        onetimeAMonth: '1 x om måneden ',
        wellEnoughButDontMiss: 'er nok - men vil ikke gå glip af nogen tilbud',
        noBenefit: 'Ønsker ikke længere at modtage rabat,',
        writeMeOut: ' jeg afmelder mig',
        benefitMail: 'Tilbudsmails',
        birthdayMail: 'Fødselsdagsmails',
        tipsAndAdvice: 'Tips og gode råd',
        personalDiscount: 'Personlige rabatter',
        productReviewAndReviews: 'Produktbedømmelse og anmeldelser',
        stillReceiveUpdatesAboutDelivery: 'Du vil stadig modtage updates om dine bestillinger og leveringer',
        feedBackAndTips: 'Har du ideer eller feedback til os?',
        cancel: 'Annuller',
        benefitDogCat: 'Vil du også modtage tilbud til hund eller kat?',
        iWantBenefitFor: 'Jeg modtager også gerne tilbud til ',
        dogs: 'Hunde',
        cats: 'Katte',
        dogsAncCats: 'Hunde og Katte',
        no: 'Jeg frabeder ',
        receiveMoreBenefitFor: 'mig tilbud til hunde/katte',
        giveMe: 'Jeg modtager gerne ',
        allBenefit: 'alle tilbud',
        average2MailsAWeek: '(ca. 2 tilbudsmails om ugen)',
        oneTime2Weeks: '1 x hver anden uge',
        save: 'Gem',
        received: '',
        selectVariant: 'Vælg variant',
        YouAreSuccessfullyUnsubscribedFor: 'Du er afmeldt for:',
        checkYourEmail: 'Kontroller din e-mailadresse',
        noOptionSelected: 'Ingen mulighed er valgt',
    },
    algoliaSearch: {
        mqc: {
            max: 'Max',
            perCustomer: 'per kunde',
        },
        searchButton: 'Søg',
        searchPlaceholder: 'Søg produkt',
        searchBarInputPlaceholder: 'Søg produkt',
        searchBarInputPlaceholderApp: '6000+ produkter',
        noResultsContentTitleCategory: 'Der er desværre ikke fundet nogen produkter med dine valgte filtre',
        noResultsContentTitle:
            'Vi kunne ikke finde <b>nogen resultater</b> for <span class="algolia-listing-no-results__content-title--brand">“{query}“</span>',
        noResultsContentListTitle: 'Hvad kan du gøre:',
        noResultsContentListItemOne: 'Kontroller stavningen af søgte ord',
        noResultsContentListItemOneCategory: 'Fjern et eller flere af valgte filtre',
        noResultsContentListItemTwo: 'Søgte du på et mærkenavn? Det kan være, vi desværre (endnu) ikke fører det mærke',
        noResultsContentListItemTwoCategory: 'Klik på ’Slet alt’ for at starte med nye valg',
        noResultsContentListItemThree: 'Prøv et andet søgeord',
        noResultsWithQuery: 'Intet søgeresultat for <b>"{query}"</b>',
        searchHistoryTitle: 'Du har tidligere søgt på',
        searchResultsHeader: '<b>{resultCount}</b> resultaten voor <b>"{query}"</b> in alle artikelen.',
        searchResultsHeaderSubtitle: 'Verfijn uw resultaten met onderstaande filters.',
        searchResultsTitle: 'Søgeresultat',
        popularProductsTitle: 'Favoritter',
        popularCategoriesTitle: 'Populære kategorier',
        queryMirrorTitle: 'Din søgning',
        resultsHitsProducts: 'Produkter',
        resultsHitsDelete: 'Slet alt',
        resultsHitsFilter: 'Filtrering',
        resultsHitsFilterNote: 'Benyt filtre til hurtigere at finde det du søger',
        fiterPanelMobileHeaderTitle: 'Filtrering',
        fiterPanelMobileHeaderSubtext: 'Benyt filtre til hurtigere at finde det du søger',
        fiterPanelMobileDeleteFilters: 'Slet alt',
        fiterPanelMobileFilteredProductAmount: 'produkter',
        fiterPanelMobileSaveSelection: 'Gem valg',
        fiterPanelMobileFooterTextPartOne: 'Filter',
        fiterPanelMobileFooterTextPartTwo: 'resultater',
        hitItemFromLabel: 'fra',
        hitItemViewProduct: 'Se product',
        refinementListViewMore: 'Mere…',
        refinementListViewLess: 'Se mindre...',
        refinementListRangeBoxInbetween: 'til',
        unAvailableNotePartOne: 'o',
        unAvailableNotePartTwo: 'igen tilgængelig',
        filters: {
            priceReduction: {
                on: 'Ja',
                off: 'Ingen',
            },
        },
    },
    algoliaRecommend: {
        recommendedProducts: 'Lignende produkter',
        recommendedProductsSubtitle: 'Anderledes, men også top!',
        boughtTogether: 'Ofte købt sammen',
        boughtTogetherSubtitle: 'Klar på én gang!'
    },
    mobileMenu: {
        makeYourChoice: 'Træf dit valg',
    },
    combinationPromotion: {
        op: 'Få på lager',
        bonus: 'Bonusbag',
        twoPlusOneFree: '2 + 1 Gratis',
        minusTenPercent: '-10%',
        minusTwentyPercent: '-20%',
        minusTwentyFivePercent: '-25%',
        minusThirtyPercent: '-30%',
        minusFortyPercent: '-40%',
        minusFiftyPercent: '-50%',
        minusSixtyPercent: '-60%',
        minusSeventyPercent: '-70%',
    },
    resetPassword: {
        passwordError: 'Dine Passwords stemmer ikke overeens',
        passwordForgot: 'Glemt Password',
        createNewPassword: 'Opret nyt Password',
        description:
            'Udfyld din e-mail adresse til din konto. Så sender vi et link til din e-mail adresse, hvormed du kan oprette et nyt Password',
        email: 'E-mail adresse',
        note: 'Det kan tage lidt tid, før du modtager dit Link. Vent venligst 4 minutter med at anmode om et nyt Link. Så undgår du at modtage et link, der ikke er aktiveret.',
        setNewPassword: 'Indfør et nyt Password',
        chooseNewPassword: 'Vælg dit nye Password',
        newPassword: 'Nyt Password',
        reenterPassword: 'Skriv dit nye Password igen',
        passwordsDontMatch: 'Password i felt 2 er ikke magen til felt 1',
        passwordsDontMatchError: 'Dine Passwords stemmer ikke overens',
        submit: 'bekræfte',
    },
};
export default messages;
